import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { ExtendedBgpTables } from "./BgpTablesPage";

export function makeBgpFields(): FilterField<ExtendedBgpTables>[] {
  const fields: FilterField<ExtendedBgpTables>[] = [
    {
      label: "Prefix",
      key: "prefix",
      accessor: (r) => r.prefix,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Family",
      key: "family",
      accessor: (r) => r.family,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Neighbour",
      key: "neighbour",
      accessor: (r) => r.neighbor,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local preference",
      key: "localpreference",
      accessor: (r) => r.localPref,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Community",
      key: "community",
      accessor: (r) => r.community,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Extended community",
      key: "extendedcommunity",
      accessor: (r) => r.extendedCommunity,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Direction",
      key: "direction",
      accessor: (r) => r.direction,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Router ID",
      key: "routerid",
      accessor: (r) => r.routerId || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "AS Path",
      key: "aspath",
      accessor: (r) => r.asPath || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local IP",
      key: "localip",
      accessor: (r) => r.localIp || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local AS",
      key: "localas",
      accessor: (r) => r.localAs || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Peer AS",
      key: "peeras",
      accessor: (r) => r.peerAs || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Subnet",
      key: "subnet",
      accessor: (r) => r.subnet || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Route Table",
      key: "routetable",
      accessor: (r) => r.route_table || "",
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

